import { keepPreviousData, queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { CurrentUser, Portal, Role } from '@/features/auth/types'
import type { ListParams } from '@/types/api'

export type ManagedUser = CurrentUser

export interface RoleOption {
  value: Role
  label: string
  portals: Portal[]
}

export const usersQuery = (params: ListParams & Record<string, string | number | undefined>) =>
  queryOptions({
    queryKey: ['users', 'list', params],
    queryFn: () => api.page<ManagedUser>('/users', params),
    placeholderData: keepPreviousData,
  })
export const rolesQuery = () =>
  queryOptions({
    queryKey: ['users', 'roles'],
    queryFn: () => api.get<RoleOption[]>('/users/roles'),
    staleTime: Infinity,
  })

export interface UserPayload {
  name: string
  email: string
  role: Role
  phone: string | null
  password: string | null
  isActive: boolean
}

export function useSaveUser() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...payload }: UserPayload & { id?: number }) =>
      id ? api.put<ManagedUser>(`/users/${id}`, payload) : api.post<ManagedUser>('/users', payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  })
}
